interface Props {
  user: {
    name: string;
    real_name: string;
    user_id: number;
    has_buy?: number;
    lt_code?: string;
    mobile: string;
  } | null;
}

export const DisplayUser = ({ user }: Props) => {
  if (!user) {
    return <div className="text-xs text-gray-500">无</div>;
  }
  return (
    <div className="text-xs">
      <div>
        用户 ID: <b>{user.user_id}</b>
      </div>
      <div>
        手机号: <b>{user.mobile}</b>
      </div>
      <div>
        姓名: <b>{user.real_name}</b>
      </div>
      {user.lt_code && (
        <div>
          绿途CODE: <b>{user.lt_code}</b>
        </div>
      )}
      {user.has_buy && (
        <div>
          是否购买: <b>{user.has_buy === 1 ? '是' : '否'}</b>
        </div>
      )}
    </div>
  );
};
